// extracted by mini-css-extract-plugin
module.exports = {"userInfoStyle":"_3kR3Am8nCmmO71XGWgdtqy"};